<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack"><img src="@/assets/img/appointment/back.svg" /></div>
      <div class="nav-title d-allcenter overflow">场馆介绍</div>
      <div class="nav-right"></div>
    </div>
    <div class="content">
      <div class="weight" style="font-size: 14px">{{ describe.name }}</div>
      <div class="d-allcenter d-wrap" style="margin-top: 8px">
        <div class="venues-each">
          <img :src="describe.img" style="width: calc(100vw - 32px); border-radius: 10px" />
          <div class="main-info mt-16" v-html="describe.profile"></div>
        </div>
      </div>
    </div>
    <!-- <div class="box-scroll">
      <div class="d-around orderBtn-box">
        <div class="orderBtn-full">
          <div class="d-column d-aligncnter">
            <div class="d-aligncnter" style="color: #ffda88">
              <div>1月8日</div>
              <div>余0</div>
            </div>
            <div class="">马上预约</div>
          </div>
        </div>
        <div class="orderBtn">
          <div class="d-column d-aligncnter">
            <div class="d-aligncnter" style="color: #ffda88">
              <div>1月8日</div>
              <div>余5</div>
            </div>
            <div class="">马上预约</div>
          </div>
        </div>
        <div class="orderBtn">
          <div class="d-column d-aligncnter">
            <div class="d-aligncnter" style="color: #ffda88">
              <div>1月8日</div>
              <div>余5</div>
            </div>
            <div class="">马上预约</div>
          </div>
        </div>
        <div class="orderBtn">
          <div class="d-column d-aligncnter">
            <div class="d-aligncnter" style="color: #ffda88">
              <div>1月8日</div>
              <div>余5</div>
            </div>
            <div class="">马上预约</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { getVenueProfile } from '@/api/api-venueOrder'
export default {
  data() {
    return {
      describe: `体育场馆是学校开展体育教学、训练、竞赛、锻炼、艺术排练展演、大型会议等活动的重要场所。 学校教学日历安排向本校师生员工、免费开放，部分场馆经预约后向社会免费开放。 校外人员须先支付费用后进入场馆，校友费用优惠，费用由学校统一收取。 人员预约后提前15分钟可进场，结束时间到后不能再进场，期间出入不做限制。`,
      list: [{ date: '1月8号', date2: '1月8号' }],
      vId: '',
    }
  },
  mounted() {
    this.vId = this.$route.query.venues
    this.getVenueProfileData()
  },
  methods: {
    pageToBack() {
      this.$router.go(-1)
    },
    getVenueProfileData() {
      getVenueProfile(this.vId).then((res) => {
        if (res.data.statusCode == 1) {
          this.describe = res.data.obj
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.model {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 2.801px 8.403px 31.122px -4.046px rgba(22, 52, 80, 0.1);
  margin-top: 16px;
  color: #464646;
}
.mt-16 {
  margin-top: 16px;
}
.venues-each {
  //   width: 347px;
  //   height: 192px;
  border-radius: 8px;
  position: relative;
  margin: 8px;
  .bg-color {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #002417 0.15%, rgba(0, 122, 77, 0) 54.73%);
  }
  img {
    width: 100%;
  }
}
.venues-info {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}
.main-info {
  color: #2f2f2f;
  font-size: 12px;
  margin-bottom: 64px;
}
.box-scroll {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: scroll;
  background: #fff;
}
.orderBtn-box {
  width: calc(100% - 32px);
  min-width: 344px;
  height: 44px;
  padding: 16px;
}
.orderBtn {
  padding: 8px 12px;
  border-radius: 8px;
  background: #339571;
  color: #fff;
  font-size: 12px;
}
.orderBtn-full {
  padding: 8px 12px;
  border-radius: 8px;
  background: #339571;
  color: #fff;
  font-size: 12px;
  opacity: 0.5;
}
</style>
